import useAction from '../utils/useAction';

export const makeActionHandler = (action: any, params: any): (() => void) => {
	const { creditKindWinnings } = useAction(params);

	switch (action.id) {
		case 'credit':
			return () => {
				creditKindWinnings();
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
